import React, { useRef, useState } from "react";
import { Layout } from "../../../shared/Layout/Layout";
import bg from "../../../../images/services/team.jpg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import toast, { Toaster } from "react-hot-toast";
import Carousel from "../../Carousel";

const API_URL = process.env.REACT_APP_API_URL || "";

const Contact = () => {
  const form = useRef();

  const [fileCount, setFileCount] = useState(0);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    from_name: "",
    university: "",
    country: "",
    course: "",
    email: "",
    phone: "",
    files: [],
    message: "",
  });

  const resetForm = () => {
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }
    setFileCount(0);
    setFormData({
      from_name: "",
      university: "",
      country: "",
      course: "",
      email: "",
      phone: "",
      files: [],
      message: "",
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!API_URL) {
      toast.error("Email service is not configured.");
      return;
    }

    setLoading(true);

    try {
      const payload = new FormData(form.current);
      const response = await fetch(`${API_URL}/api/submit-assignment`, {
        method: "POST",
        body: payload,
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || "Email request failed");
      }

      toast.success("Assignment submitted successfully!");
      resetForm();
    } catch (error) {
      console.error("Email sending failed:", error);
      toast.error(error.message || "Assignment submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    setFileCount(files?.length || 0);
    setFormData((prevFormData) => ({
      ...prevFormData,
      files: files ? Array.from(files) : [],
    }));
  };
  return (
    <div
      style={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: "center center",
        backgroundSize: "cover", // Added to cover the entire container
        backgroundAttachment: "fixed",
      }}
    >
      <div className="bg-gray-700 opacity-95">
        <Toaster position="bottom-left" reverseOrder={true} />
        <Layout>
          <div className="mt-0 py-24  dark:text-slate-200 rounded-md ">
            <div className="  grid grid-cols-1 md:grid-cols-admin2 justify-between items-center md:items-start">
              <div className=" flex flex-col justify-end space-y-6 mt-10 md:mt-0 w-full md:w-4/5">
                <Carousel />
              </div>
              <div>
                <div className=" flex items-center justify-center mt-8 md:mt-0">
                  <form ref={form} onSubmit={submitHandler} className="w-full">
                    <div className="px-4 py-6 w-full space-y-5 lg:w-3/4 bg-slate-800 dark:bg-slate-800 text-primary p-3 rounded-md shadow-lg">
                      <h4 className="text-2xl text-slate-200">
                        Upload
                        <span className="text-2xl text-primary ml-2">
                          Assignment
                        </span>
                      </h4>
                      <div>
                        <input
                          type="text"
                          placeholder="Enter your name"
                          className="h-14 px-3 text-lg w-full border-solid border-2  rounded-md"
                          required
                          name="from_name"
                          value={formData.from_name}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          placeholder="Enter name of university"
                          className="h-14 px-3 text-lg w-full border-solid border-2  rounded-md"
                          name="university"
                          value={formData.university}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          placeholder="Enter country name"
                          className="h-14 px-3 text-lg w-full border-solid border-2  rounded-md"
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          placeholder="Enter course"
                          className="h-14 px-3 text-lg w-full border-solid border-2  rounded-md"
                          name="course"
                          value={formData.course}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          placeholder="Enter email address"
                          className="h-14 px-3 text-lg w-full border-solid border-2  rounded-md"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <PhoneInput
                          country="in"
                          containerClass="!w-full"
                          inputClass="!h-14 !w-full !text-lg !border-solid !border-2 !rounded-md !pl-12"
                          buttonClass="!h-14 !border-solid !border-2 !rounded-l-md !bg-white"
                          dropdownClass="!text-base"
                          inputProps={{
                            name: "phone",
                            required: true,
                          }}
                          placeholder="Enter phone number"
                          value={formData.phone}
                          onChange={(phone) =>
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              phone: phone,
                            }))
                          }
                        />
                      </div>
                      <div style={{ position: "relative" }}>
                        <label
                          htmlFor="fileUpload"
                          className="text-slate-200 block mb-2"
                        >
                          Upload Assignment Files (PDF, JPG, PNG, TXT, DOCX
                          etc):
                        </label>
                        {/* <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf, .jpg, .png"
                          multiple
                          className="h-14 w-full opacity-0 absolute bg-slate-200"
                          style={{ zIndex: 1 }}
                          onChange={handleFileChange}
                        /> */}
                        <input
                          multiple
                          className="h-14 w-full opacity-0 absolute bg-slate-200"
                          type="file"
                          accept="image/*,video/*,.pdf,.txt,.html,.js,.css,.odt,.odp,.odf,.docx"
                          name="fichiersSupp"
                          id="fileInput"
                          onChange={handleFileChange}
                        />
                        <div className="h-14 bg-slate-200 text-lg w-full border-solid border-2 rounded-md flex items-center justify-center">
                          <span className="text-slate-800">
                            {fileCount === 0
                              ? "Choose File"
                              : `${fileCount} ${
                                  fileCount <= 1 ? "file" : "files"
                                } uploaded`}
                          </span>
                        </div>
                      </div>
                      <div>
                        <textarea
                          className="resize rounded-md w-full h-14 px-3"
                          placeholder="Assignment details.."
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                      <button
                        type="submit"
                        disabled={loading}
                        className="bg-primary px-3 text-gray-200 w-full rounded-md py-2 rounded-m border-solid border-2 border-transparent hover:scale-105 transition-all duration-200 delay-100 ease-in-out"
                      >
                        {loading ? "Processing..." : " Submit Now"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    </div>
  );
};

export default Contact;
